export enum PermissionCategory {
  WEB = "WEB",
  API = "API",
}
